module.exports = __webpack_public_path__ + "media/src/assets/images/floor_plan-ac161113d335094283fd0eadea429f61.png";